import * as Redux from "redux";
import { CoughAnalysisSetType } from "../../misc/api/apiTypes";
import { WebPortalLegacyClientInternal } from "../../misc/api/WebPortalTokenClient";
import { FetchAnalysisSetsAction } from "../CoughAnalysisActions";

export enum ActionType {
    OpenManuallySendModal = "OpenManuallySendModal",
    InitializeQATypes = "InitializeQATypes",
    RequestQATypes = "RequestQATypes",
    ReceiveQATypes = "ReceiveQATypes",
    SelectQAType = "SelectQAType",
    SendForQAReview = "SendForQAReview",
    DisableActionButton = "DisableActionButton",
    OtherAction = "OtherAction"
}

export class RequestQATypesAction implements Redux.Action {
    type: ActionType.RequestQATypes;

    static create(): RequestQATypesAction {
        return {
            type: ActionType.RequestQATypes
        };
    }
}

export class ReceiveQATypesAction implements Redux.Action {
    type: ActionType.ReceiveQATypes;
    qaTypes: Array<CoughAnalysisSetType>;

    static create(qaTypes: Array<CoughAnalysisSetType>): ReceiveQATypesAction {
        return {
            type: ActionType.ReceiveQATypes,
            qaTypes: qaTypes
        };
    }
}

export class InitializeQATypeAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal) {
        return dispatch => {
            dispatch(RequestQATypesAction.create());

            legacyClient.fetchQAAnalysisSetTypes().then(types => {
                dispatch(ReceiveQATypesAction.create(types));
            });
        };
    }
}

export class InitializeQATypesAction implements Redux.Action {
    type: ActionType.InitializeQATypes;

    static create(): InitializeQATypesAction {
        return {
            type: ActionType.InitializeQATypes
        };
    }
}

export class DisableActionButtonAction implements Redux.Action {
    type: ActionType.DisableActionButton;

    static create(): DisableActionButtonAction {
        return {
            type: ActionType.DisableActionButton
        };
    }
}

export class SendForQAReviewOrAdditionalCoughCountAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, analysisSetId: string, selectedQAType: string, currentStudyId: string, onClose: () => void) {
        return dispatch => {
            dispatch(DisableActionButtonAction.create());
            return legacyClient.createManualQASet(analysisSetId, selectedQAType).then(() => {
                onClose();
                dispatch(FetchAnalysisSetsAction.create(legacyClient, currentStudyId));                
            });
        };
    }
}

export class SelectQATypeAction implements Redux.Action {
    type: ActionType.SelectQAType;
    qaTypeId: string;

    static create(qaTypeId: string): SelectQATypeAction {
        return {
            type: ActionType.SelectQAType,
            qaTypeId: qaTypeId
        };
    }
}

export class OtherAction implements Redux.Action {
    type: ActionType.OtherAction;

    static create(): OtherAction {
        return {
            type: ActionType.OtherAction
        };
    }
}


export type Action =
    RequestQATypesAction
    | ReceiveQATypesAction
    | SelectQATypeAction
    | DisableActionButtonAction
    | OtherAction;
